<template>
  <div id="list">
<!--    <div class="bg-color-black">-->
<!--      <div class="d-flex pt-2 pl-2">-->
<!--        <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem;">-->
<!--           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">服务机构区域</span>-->
<!--        </span>-->
<!--      </div>-->
<!--      <div class="d-flex jc-center" style="clear: both;display: flex;justify-content: space-between;width: 100%;height: 40%">-->
<!--        <Echart-->
<!--            id="areaChart"-->
<!--            :options="options"-->
<!--            height="100%"-->
<!--            width="100%"-->
<!--        ></Echart>-->
<!--      </div>-->
      <div class="d-flex pt-2 pl-2" style="">
        <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem;">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">服务机构领域</span>
        </span>
      </div>
      <div class="d-flex jc-center" style="clear: both;display: flex;justify-content: space-between;width: 100%;height: 90%">
        <Echart
            id="natureChart"
            :options="options2"
            height="100%"
            width="100%"
        ></Echart>
      </div>
    </div>
<!--  </div>-->
</template>

<script>
import Echart from '@/common/echart'
import sciApi from '@/api/index.js'
// let Chart1
let Chart2
export default {
  data() {
    return {
      options:{},
      options2:{},
      val:[],
      sum:[],
      tag:'',
      Num:{},
      Tum:{},
        // xData: ["政策直播间","创新课堂", "管理学院", "项目路演", "主题沙龙","峰会论坛","智汇两江","技术经理人培训","创新服务","技术转移"],
        seriesData: [],

    };
  },

  watch:{
    setregion:{
      immediate: true,
      deep: true,
      handler(val) {
        this.tag = val
      }

    }
  },
  computed:{
    setregion() {
      // console.log(this.$store.state.region)
      return this.$store.state.region
    }
  },
  components: {
    Echart
  },
  mounted() {
    this.init().then(()=>{
      let num=[]
      let tum=[]
      for (let i in this.val){
        if (this.val[i].name !=='政策'){
            num.push(this.val[i])
        }
      }
      for (let i in this.sum){
        if (this.sum[i].name !=='1'){
          tum.push(this.sum[i])
        }
      }
      // this.options.series[0].data=num
      this.options2.series[0].data=tum
      // Chart1.setOption(JSON.parse(JSON.stringify(this.options)),true);
      Chart2.setOption(JSON.parse(JSON.stringify(this.options2)),true);
    })
    // this.options = {
    //   color: [
    //     "#37a2da",
    //     "#32c5e9",
    //     "#9fe6b8",
    //     "#ffdb5c",
    //     "#ff9f7f",
    //     "#fb7293",
    //     "#e7bcf3",
    //     "#8378ea"
    //   ],
    //   tooltip: {
    //     trigger: "item",
    //     formatter: "{b}<br/>{c}个"
    //   },
    //   series: [
    //     {
    //       top:'6%',
    //       name: "服务机构",
    //       type: "pie",
    //       // radius: ["50%", "50%"],
    //       // roseType: "area",
    //       avoidLabelOverlap:true,
    //       center: ["50%", "50%"],
    //       data: []
    //     }
    //   ]
    // },
        this.options2 = {
          color: [
            "#37a2da",
            "#32c5e9",
            "#9fe6b8",
            "#ffdb5c",
            "#ff9f7f",
            "#fb7293",
            "#e7bcf3",
            "#8378ea"
          ],
          tooltip: {
            trigger: "item",
            formatter: "{b}<br/>{c}场"
          },
          calculable: true,
          series: [
            {
              top:'6%',
              name: "产品总数",
              type: "pie",
              radius: ['50%', '70%'],
              avoidLabelOverlap:true,
              // radius: ["50%", "50%"],
              // roseType: "area",
              center: ["50%", "50%"],
              data:[]
            }
          ]
        }
     this.drawLine();
  },
  methods: {
    async init(){
      // const that = this;
      // await sciApi.selectMall({})
      await sciApi.selectMall({level1: "384354211555600203",pageSize: 1000,pageNum: 1}).then((data)=>{
        // data 就是接口返回值
        this.val=[]
        this.sum=[]
        this.seriesData = data.list || []
          this.seriesData.forEach((item) => {
            this.Num[item.mapAreaDisplay] = item
            this.Tum[item.level2Display]=item
          })
        let title = Object.keys(this.Tum)
        console.log(title,'...')
        let names = Object.keys(this.Num)
        title.forEach(()=>{
          this.sum.push({name:'1',value:0})
        })
        names.forEach(()=>{
          this.val.push({name:'政策',value:0})
        })
        this.seriesData.forEach((item) => {
          let idx = names.indexOf(item.mapAreaDisplay)
          if (idx != -1) {
            //交易次数
              this.val[idx].name = names[idx] || '政策'
              this.val[idx].value += Number(item.mapNum||0 )
          }
          let pi = title.indexOf(item.level2Display)
          if (pi != -1) {
            //交易次数
            this.sum[pi].name = title[pi] || '1'
            this.sum[pi].value += Number(item.mapNum||0 )
          }
        })

      })
    },
    drawLine:function (){
      //基于准备好的dom，初始化echarts实例
      // Chart1 = this.$echarts.init(document.getElementById('areaChart'))
      Chart2 = this.$echarts.init(document.getElementById('natureChart'))
      // Chart1.setOption(JSON.parse(JSON.stringify(this.options)));
      Chart2.setOption(JSON.parse(JSON.stringify(this.options2)));
      // option && myChart.setOption(option);
    },
  }
};
</script>

<style lang="scss">
#list {
  padding: 0.2rem;
  height:100%;
  width: 100%;
  //border-radius: 0.0625rem;
  .bg-color-black {
    padding: 0.0625rem;
    height: 100%;
    border-radius: 0.125rem;
  }
  .text {
    color: #c3cbde;
  }
  .chart-box {
    margin-top: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;
    .active-ring-name {
      padding-top: 0.125rem;
    }
  }
.data{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30%;
  box-sizing: border-box;
  background: #142957;
  font-size: 16px;
 height: 2.5rem;
  padding: 0.4rem;
  border-radius: 0 0.5rem 0 0.5rem;
  .item h4{
    display: block;
    margin-bottom: 0.2rem;
    font-size:28px;
    color: #fff;
    font-weight: normal;
  }
}
  .bottom-data {
    .item-box {
      float: left;
      position: relative;
      width: 33%;
      color: #d3d6dd;
      // 金币
      .coin {
        position: absolute;
        left: 0.1rem;
        top: 0.2125rem;
        font-size: 0.25rem;
        color: #ffc107;
      }
      .colorYellow {
        color: yellowgreen;
      }
    }
  }
}
</style>